import React from 'react';
import { ListItem } from '@mui/material';
import { ClassNameMap } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(1),
    fontSize: theme.typography.body2.fontSize
  }
}));

const useListItemStyles = makeStyles(() => ({
  root: {
    padding: 0
  }
}));

type OptionItemProps = {
  testId?: string;
  value: React.ReactNode | string;
  icon?: JSX.Element;
  classes?: ClassNameMap;
};

export const LabelOptionItem: React.FC<OptionItemProps> = ({
  testId,
  value,
  icon,
  classes: cls
}: OptionItemProps) => {
  const classes = useStyles({ classes: cls });
  const listItemClasses = useListItemStyles();

  return (
    <ListItem component="div" classes={listItemClasses} data-testid={testId}>
      {icon}
      <Typography variant="inherit" classes={classes} color="inherit">
        {value}
      </Typography>
    </ListItem>
  );
};

export default LabelOptionItem;
